module.exports = __webpack_public_path__ + "img/89_15.8d9c445f.png";